export default __webpack_public_path__ + "static/media/BoardRoom-old.825e72ca.png";